import React, { Component } from 'react';
import {Modal, ModalBody, ModalHeader, Button} from "reactstrap";
import {serverPath} from "./common";
import axios from "axios";


class SignupVerificationModal extends Component{
	constructor(props){
	    super(props);

		this.state = {
			isOpen: props.isOpen
		};

		this.renderText = this.renderText.bind(this);
		this.toggleModal = this.toggleModal.bind(this);
	};

	componentWillReceiveProps(newProps) {
		this.setState({
			isOpen: newProps.isOpen
		});
	}
	toggleModal() {
		if(this.state.isOpen) {
			//notify parent that modal is closed
            this.props.closeModalHandler();
        }
        else {
            this.setState({isOpen: !this.state.isOpen});
        }
	}
	renewToken(){
		const params = new URLSearchParams();
		params.append('action', 'renewToken');
		//no need for callbacks
		axios.post(serverPath+"authService.php", params);
		this.toggleModal();
	}
	renderText(){
		if(this.props.firstTime){
			return(
				<p>
					Dobrodošli! Proverite email adresu koju ste naveli u formi i idite na link koji vam je tamo poslat.
					Link važi 8h.
					Ukoliko vam mail nije stigao, proverite spam folder ili klkinite
						<Button onClick={this.renewToken} size={'sm'} color={'primary'}> ovde </Button> da vam se
					pošalje novi kod!
				</p>

			);
		}
		else{
			return(
				<p>
					Vaš kod za verifikaciju je istekao! Klknite
					<Button onClick={this.renewToken} color={"primary"} size={'sm'}>ovde</Button> da obnovite kod.
					Biće poslat na email adresu koju ste naveli u formi.
				</p>
			);

		}
	}
	render(props){
	    return(
			<Modal isOpen={this.state.isOpen} toggle={this.toggleModal}>
				<ModalHeader toggle={this.toggleModal}>
                	Verifikujte vaš nalog
				</ModalHeader>
				<ModalBody>
					{this.renderText()}
				</ModalBody>
			</Modal>
		);
	}
}

export {SignupVerificationModal}